/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const SERVICE_NOW_CATEGORIES_RESPONSE = {
	categories: ["Laptop", "Desktop", "Mobile", "Tablet"]
};

export const SERVICE_NOW_GENERAL_INFORMATION_RESPONSE = {
	totalEmission: {
		label: "Total Emissions",
		value: 420,
		unit: "kgCO2e"
	},
	scope2Emission: {
		label: "Scope 2 Emissions",
		value: 120,
		unit: "kgCO2e"
	},
	scope3Emission: {
		label: "Scope 3 Emissions",
		value: 300,
		unit: "kgCO2e"
	},
	totalAssetsCount: {
		label: "Total Assets",
		value: 620,
		unit: "pcs"
	},
	accountedAssetsInReportingPeriod: {
		label: "Accounted Assets in Reporting Period",
		value: 580,
		unit: "pcs"
	},
	manufacterCount: {
		label: "Manufacturers",
		value: 12,
		unit: ""
	}
};

export const SERVICE_NOW_MANUFACTURERS_RESPONSE = {
	manufacturers: ["Dell", "HP", "Lenovo", "Apple"]
};

export const SERVICE_NOW_DEVICE_CARBON_FOOTPRINT_RESPONSE = {
	title: "Devices CO2 by Category",
	barSeries: [
		{
			name: "Emissions",
			bars: [
				{ name: "Laptop", value: 120, unit: "kgCO2e" },
				{ name: "Desktop", value: 90, unit: "kgCO2e" },
				{ name: "Mobile", value: 45, unit: "kgCO2e" },
				{ name: "Tablet", value: 30, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_SCOPE_CARBON_FOOTPRINT_RESPONSE = {
	title: "Devices CO2 by Scope",
	barSeries: [
		{
			name: "Scope 1",
			bars: [
				{ name: "Manufacturing", value: 55, unit: "kgCO2e" },
				{ name: "Usage", value: 35, unit: "kgCO2e" }
			]
		},
		{
			name: "Scope 2",
			bars: [
				{ name: "Manufacturing", value: 40, unit: "kgCO2e" },
				{ name: "Usage", value: 28, unit: "kgCO2e" }
			]
		},
		{
			name: "Scope 3",
			bars: [
				{ name: "Manufacturing", value: 70, unit: "kgCO2e" },
				{ name: "Usage", value: 45, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_MANUFACTURER_EMISSION_PIE_RESPONSE = {
	title: "Manufacturer Emissions",
	PieChartSlice: [
		{ name: "Dell", value: 120, unit: "kgCO2e" },
		{ name: "HP", value: 95, unit: "kgCO2e" },
		{ name: "Lenovo", value: 70, unit: "kgCO2e" },
		{ name: "Apple", value: 40, unit: "kgCO2e" }
	]
};

export const SERVICE_NOW_DEVICE_STATUS_PIE_RESPONSE = {
	title: "Device Status Emissions",
	PieChartSlice: [
		{ name: "In Use", value: 160, unit: "kgCO2e" },
		{ name: "In Storage", value: 60, unit: "kgCO2e" },
		{ name: "Disposed", value: 25, unit: "kgCO2e" }
	]
};

export const SERVICE_NOW_MODELS_BAR_RESPONSE = {
	title: "Most Impactful Models",
	barSeries: [
		{
			name: "Emissions",
			bars: [
				{ name: "Model X", value: 60, unit: "kgCO2e" },
				{ name: "Model Y", value: 45, unit: "kgCO2e" },
				{ name: "Model Z", value: 35, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_MODELS_BAR_PER_DEVICE_RESPONSE = {
	title: "Emissions per Device",
	barSeries: [
		{
			name: "Emissions",
			bars: [
				{ name: "Model X", value: 3.2, unit: "kgCO2e" },
				{ name: "Model Y", value: 2.5, unit: "kgCO2e" },
				{ name: "Model Z", value: 1.8, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_LOCATIONS_BAR_RESPONSE = {
	title: "Emissions by Location",
	barSeries: [
		{
			name: "Emissions",
			bars: [
				{ name: "Italy", value: 80, unit: "kgCO2e" },
				{ name: "Germany", value: 65, unit: "kgCO2e" },
				{ name: "Spain", value: 50, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_LOCATIONS_BAR_PER_DEVICE_RESPONSE = {
	title: "Emissions per Device by Location",
	barSeries: [
		{
			name: "Emissions",
			bars: [
				{ name: "Italy", value: 2.8, unit: "kgCO2e" },
				{ name: "Germany", value: 2.2, unit: "kgCO2e" },
				{ name: "Spain", value: 1.9, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_TOTAL_OVER_TIME_RESPONSE = {
	title: "Total Devices Emissions Over Time",
	lineSeries: [
		{
			name: "Total",
			linePoints: [
				{ name: "2024-01", value: 40, unit: "kgCO2e" },
				{ name: "2024-02", value: 55, unit: "kgCO2e" },
				{ name: "2024-03", value: 70, unit: "kgCO2e" },
				{ name: "2024-04", value: 60, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_LOCATION_OVER_TIME_RESPONSE = {
	title: "Operational CO2 by country",
	lineSeries: [
		{
			name: "IT",
			linePoints: [
				{ name: "2023-01", value: 12000, unit: "kgCO2e" },
				{ name: "2023-02", value: 18500, unit: "kgCO2e" },
				{ name: "2023-03", value: 20300, unit: "kgCO2e" },
				{ name: "2023-04", value: 15700, unit: "kgCO2e" },
				{ name: "2023-06", value: 22000, unit: "kgCO2e" },
				{ name: "2023-09", value: 19800, unit: "kgCO2e" },
				{ name: "2024-01", value: 21000, unit: "kgCO2e" },
				{ name: "2024-03", value: 17500, unit: "kgCO2e" },
				{ name: "2024-06", value: 23000, unit: "kgCO2e" },
				{ name: "2024-09", value: 20500, unit: "kgCO2e" }
			]
		},
		{
			name: "ES",
			linePoints: [
				{ name: "2023-02", value: 8200, unit: "kgCO2e" },
				{ name: "2023-04", value: 11300, unit: "kgCO2e" },
				{ name: "2023-07", value: 9800, unit: "kgCO2e" },
				{ name: "2023-10", value: 13500, unit: "kgCO2e" },
				{ name: "2024-02", value: 10200, unit: "kgCO2e" },
				{ name: "2024-05", value: 14700, unit: "kgCO2e" },
				{ name: "2024-08", value: 12300, unit: "kgCO2e" }
			]
		},
		{
			name: "DE",
			linePoints: [
				{ name: "2023-01", value: 31000, unit: "kgCO2e" },
				{ name: "2023-03", value: 28500, unit: "kgCO2e" },
				{ name: "2023-05", value: 33200, unit: "kgCO2e" },
				{ name: "2023-08", value: 29700, unit: "kgCO2e" },
				{ name: "2023-11", value: 35000, unit: "kgCO2e" },
				{ name: "2024-01", value: 32500, unit: "kgCO2e" },
				{ name: "2024-04", value: 36800, unit: "kgCO2e" },
				{ name: "2024-07", value: 30100, unit: "kgCO2e" },
				{ name: "2024-10", value: 28900, unit: "kgCO2e" }
			]
		},
		{
			name: "AR",
			linePoints: [
				{ name: "2023-03", value: 4500, unit: "kgCO2e" },
				{ name: "2023-06", value: 5200, unit: "kgCO2e" },
				{ name: "2023-09", value: 3900, unit: "kgCO2e" },
				{ name: "2024-03", value: 4800, unit: "kgCO2e" },
				{ name: "2024-09", value: 5500, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_LIFECYCLE_SAVINGS_OVER_TIME_RESPONSE = {
	title: "Lifecycle Savings Over Time",
	lineSeries: [
		{
			name: "Savings",
			linePoints: [
				{ name: "2024-01", value: 5, unit: "kgCO2e" },
				{ name: "2024-02", value: 6, unit: "kgCO2e" },
				{ name: "2024-03", value: 7, unit: "kgCO2e" },
				{ name: "2024-04", value: 6.5, unit: "kgCO2e" }
			]
		}
	]
};

export const SERVICE_NOW_MANUFACTURER_TABLE_RESPONSE = {
	manufacturersEmissions: [
		{
			manufacturer: "Dell",
			parts: 120,
			emissionValue: 80,
			total: 80
		},
		{
			manufacturer: "HP",
			parts: 95,
			emissionValue: 60,
			total: 60
		},
		{
			manufacturer: "Lenovo",
			parts: 70,
			emissionValue: 45,
			total: 45
		}
	]
};
